import React from "react";
import PageHeader from "../../components/PageHeader";
import RequestedQuotesListComponent from "../../components/RequestedQuotes/RequestedQuotesListComponent";

class RequestedQuotesList extends React.Component {
    componentDidMount() {
        window.scrollTo(0, 0);
    }
    render() {
        return (
            <div
                style={{ flex: 1 }}
                onClick={() => {
                    document.body.classList.remove("offcanvas-active");
                }}
            >
                <div>
                    <div className="container-fluid">
                        <PageHeader
                            HeaderText="Requested Quotes"
                            Breadcrumb={[
                                { name: "Requested Quotes", navigate: "" },
                            ]}
                        />
                        <div className="row clearfix">
                            <RequestedQuotesListComponent />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default RequestedQuotesList;
